import { useFetch } from "@common/hooks/useFetch";
import { useContext } from "react";
import { NumberOfferContext } from "../../../App";
import { ICart } from "../ICart";
import { addPortinRoute,addPortinCrossSellRoute } from "@api-routes";
import { getStateToPayload } from "../mappers/updatePortinMapper";
import { getResponseToState, ICartResponse } from "@mappers/getCartMapper";
import { IPortinForm } from "@common/portIn/IPortinForm";
import { keycloakUtils } from "src/itsf/keycloak/keycloakUtils";

export const useAddPortin = () => {
    const [addPortinState, { post }] = useFetch();
    const { setNumberOfferSelected } = useContext(NumberOfferContext);

    const addPortin = (cartOfferId: number, portinForm: IPortinForm): Promise<ICart | undefined> =>
        post<ICartResponse>(keycloakUtils.isAuthenticated() ? addPortinCrossSellRoute(cartOfferId): addPortinRoute(cartOfferId), {
            body: getStateToPayload(portinForm),
            isSecured: keycloakUtils.isAuthenticated(),
        }).then((newCartResponse) => {
            if (newCartResponse) {
                const newCart = getResponseToState(newCartResponse);

                setNumberOfferSelected(newCart.offers.length);

                return newCart;
            }

            return undefined;
        });

    return { addPortinState, addPortin };
};
